import { participantsPath } from 'app/constants';
import { QueryKeys, useDeleteParticipant } from 'data';
import DeleteModal, { IDeleteModalProps } from '../delete-modal';

export const ParticipantDeleteModal = ({ entityName, onClose, onSettled }: IDeleteModalProps) => {
  const { mutate: deleteParticipant, isLoading: isParticipantDeleting } = useDeleteParticipant();

  return (
    <DeleteModal
      title="Remove participant?"
      modalText={`Are you sure you want to remove ${entityName} ?`}
      entityName={entityName}
      successMessage={
        <div>
          Participant <strong>{entityName}</strong> was removed
        </div>
      }
      redirectPath={participantsPath}
      queryKey={QueryKeys.PARTICIPANTS}
      deleteMethod={deleteParticipant}
      onClose={onClose}
      onSettled={onSettled}
      isLoading={isParticipantDeleting}
    />
  );
};
